import { render } from "./change-sass.vue?vue&type=template&id=3df291d8&scoped=true"
import script from "./change-sass.vue?vue&type=script&lang=js"
export * from "./change-sass.vue?vue&type=script&lang=js"

import "./change-sass.vue?vue&type=style&index=0&id=3df291d8&scoped=true&lang=scss"

import exportComponent from "/var/jenkins_home/workspace/kj-wx-web-pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3df291d8"]])

export default __exports__